var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIgKds({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Agilysys_IG_KDS_-_Color",
    "data-name": "Agilysys IG KDS - Color",
    xmlns: "http://www.w3.org/2000/svg",
    width: 237,
    height: 67.997,
    viewBox: "0 0 237 67.997",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_117672",
    "data-name": "Group 117672",
    transform: "translate(83.24 21.668)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6175",
    "data-name": "Path 6175",
    d: "M483.947,165.244H478.68V127.12h5.267Z",
    transform: "translate(-478.68 -126.432)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6176",
    "data-name": "Path 6176",
    d: "M572.348,125.452l-.858,4.179a28.5,28.5,0,0,0-10.476-2.117c-9.446,0-15.227,5.782-15.227,15.914S551,158.6,561.128,158.6a26.967,26.967,0,0,0,6.869-.916V145.26h4.808V160.6a35.7,35.7,0,0,1-12.307,2.117c-12.536,0-19.978-7.9-19.978-19.291,0-11.964,7.671-20.207,20.436-20.207a26.962,26.962,0,0,1,11.391,2.232Z",
    transform: "translate(-529.645 -123.218)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6177",
    "data-name": "Path 6177",
    d: "M828.252,165.244V127.12h5.267v18.491l15.914-18.491h6.354l-16.429,18.892,17.516,19.234h-6.641l-16.716-18.892v18.892H828.25Z",
    transform: "translate(-766.772 -126.432)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6178",
    "data-name": "Path 6178",
    d: "M1015.43,127.12h10.591c13.109,0,21.753,8.129,21.753,19.062s-8.644,19.062-21.753,19.062H1015.43Zm27.076,19.062c0-9.388-7.27-14.826-16.485-14.826H1020.7v29.653h5.324c9.217,0,16.485-5.438,16.485-14.826Z",
    transform: "translate(-921.034 -126.432)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6179",
    "data-name": "Path 6179",
    d: "M1225.574,162.71a26.188,26.188,0,0,1-10.934-2.29l1.031-4.179a23.845,23.845,0,0,0,9.789,2.232c4.922,0,8.3-2.175,8.3-6.125,0-4.407-3.836-6.067-8.357-8.187-5.151-2.4-9.961-5.209-9.961-10.934,0-6.641,4.922-10.017,12.136-10.017a21.987,21.987,0,0,1,9.9,2.29l-.973,4.179a20.592,20.592,0,0,0-8.93-2.232c-4.522,0-6.927,1.889-6.927,5.382,0,3.206,1.717,4.465,6.641,6.869s11.677,5.5,11.677,12.421C1238.969,158.645,1233.016,162.71,1225.574,162.71Z",
    transform: "translate(-1085.21 -123.21)",
    fill: "#231f20"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_117674",
    "data-name": "Group 117674"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6180",
    "data-name": "Path 6180",
    d: "M298.277,29.575A14.788,14.788,0,1,0,283.49,14.787a14.787,14.787,0,0,0,14.787,14.789",
    transform: "translate(-233.634)",
    fill: "#0299d6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_117673",
    "data-name": "Group 117673",
    transform: "translate(0 13.579)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6181",
    "data-name": "Path 6181",
    d: "M44.621,83.508a15.768,15.768,0,0,1,2.872,9.79v20.747H41.176v-4.307a15.18,15.18,0,0,1-11.486,5.024c-5.672,0-9.834-3.734-9.834-9.548,0-6.317,4.81-9.476,12.275-9.979,3.086-.215,6.1-.287,8.9-.287V93.442c0-5.814-2.369-9.331-8.041-9.331a18.6,18.6,0,0,0-9.117,2.441l-1.507-4.738a21.777,21.777,0,0,1,11.772-2.942,16.741,16.741,0,0,1,3.252.31,27.226,27.226,0,1,0,7.23,4.326Z",
    transform: "translate(0 -77.21)",
    fill: "#7fbc42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6182",
    "data-name": "Path 6182",
    d: "M148.41,208.2c0,3.231,2.01,4.81,5.455,4.81a13.057,13.057,0,0,0,9.476-4.451V202.17c-2.872.144-5.313.359-7.752.645-4.02.431-7.179,1.651-7.179,5.383Z",
    transform: "translate(-122.31 -180.194)",
    fill: "#7fbc42"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIgKds);
export default __webpack_public_path__ + "static/media/IG_KDS.9209f933f53a588b6d013629ba7a60d4.svg";
export { ForwardRef as ReactComponent };